/**
 * Handles Slate fragment data transfer operations
 * Processes application/x-slate-fragment MIME type
 */
export class SlateFragmentHandler {
  constructor(editor) {
    this.editor = editor;
  }

  handle(data) {
    const decoded = decodeURIComponent(window.atob(data));
    const parsed = JSON.parse(decoded);

    if (this.editor.beforeInsertFragment) {
      this.editor.beforeInsertFragment(parsed);
    }

    this.editor.insertFragment(parsed);
    return true;
  }
}
